function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "80",
  height: "68",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "4.4",
  y: "1.31",
  width: "30.5",
  height: "27.69",
  rx: ".65",
  fill: "#FAFAFA",
  stroke: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "45.09",
  y: "1.31",
  width: "30.5",
  height: "27.69",
  rx: ".65",
  fill: "#FAFAFA",
  stroke: "#DDE0E4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.94 13.5a.5.5 0 000 1v-1zm6.1.86a.5.5 0 000-.7l-3.19-3.19a.5.5 0 10-.7.7l2.82 2.84-2.83 2.83a.5.5 0 10.7.7l3.2-3.18zm-6.1.15h5.74v-1h-5.74v1zM61.5 31.5a.5.5 0 00-1 0h1zm-.85 5.35c.2.2.5.2.7 0l3.19-3.18a.5.5 0 10-.71-.7L61 35.78l-2.83-2.83a.5.5 0 10-.7.71l3.18 3.18zm-.15-5.35v5h1v-5h-1z",
  fill: "#7E86A0"
}), /*#__PURE__*/React.createElement("rect", {
  x: "3.83",
  y: "39",
  width: "30.5",
  height: "27.69",
  rx: ".65",
  fill: "#FAFAFA",
  stroke: "#DDE0E4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.87 53.35a.5.5 0 000-1v1zm-6.1-.86a.5.5 0 000 .7l3.19 3.2a.5.5 0 10.7-.72l-2.82-2.82 2.83-2.83a.5.5 0 00-.71-.71l-3.18 3.18zm6.1-.14h-5.74v1h5.74v-1z",
  fill: "#7E86A0"
}), /*#__PURE__*/React.createElement("rect", {
  x: "45.66",
  y: "39",
  width: "30.5",
  height: "27.69",
  rx: ".65",
  fill: "#FAFAFA",
  stroke: "#DDE0E4"
})));